export const DEFAULT_MAX_PER_SIZE = 125

/** When true, product image and title in the B2B cart (page + popup) link to the PDP. */
export const ENABLE_CART_PDP_LINK = true
